export default __webpack_public_path__ + "static/media/glygen-one-page-brochure.838739e4.pdf";